import { ApiService } from './ApiService';
import apiResponse, { ApiResponse } from './ApiResponse';
import { Cookies } from 'react-cookie';
import { RawUserTermsAcceptance } from '@app/views';

export class UserTermsAcceptanceStore {
  constructor(
    private readonly api: ApiService = new ApiService(),
    private readonly cookies: Cookies = new Cookies()
  ) {}

  public async create(raw: RawUserTermsAcceptance) {
    const profile = this.cookies.get('profile');
    try {
      const response = await this.api.post(`/user/${profile.id}/terms-acceptance`, raw);
      return apiResponse.Success<UserTermsAcceptance>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async read(): Promise<ApiResponse<UserTermsAcceptance[]>> {
    const profile = this.cookies.get('profile');
    try {
      const response = await this.api.get(`/user/${profile.id}/terms-acceptance`);
      return apiResponse.Success<UserTermsAcceptance[]>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}

export type UserTermsAcceptance = {
  id: number;
  userId: number;
  termsVersion: string;
  acceptedAt: string; // ISO date string
};
